import React, { useState, useMemo } from 'react';
import { ButtonGroup } from 'reactstrap';
import { Form, Row, Col, Button } from "react-bootstrap";

function ControlPanel({ selected, setSelected }) {
    const [activeButton, setActiveButton] = useState(selected.period);

    const handleChange = (key, value) => {
        setSelected((prev) => ({
            ...prev,
            [key]: value,
        }));
        
        if (key === "period") {
            setActiveButton(value);
        }
    };
    
    const DateComponent = useMemo(() => ({ fieldKey }) => (
        <Form.Group as={Row} className=''>
            <Form.Label className='aling-items-end text-dark' column xs={3}>
                {"Pickup Cutoff Date".toUpperCase()}
            </Form.Label>
            <Col xs={9}>
                <Form.Control
                    type='date'
                    id={fieldKey}
                    defaultValue={selected.date}
                    onChange={(e) => handleChange(fieldKey, e.target.value)}
                />
            </Col>
        </Form.Group>
    ), []);

    return (
        <Row style={{ alignItems: 'center' }}>
            <Col>
                <ButtonGroup>
                    <Button
                        className='btn mr-0'
                        value={7}
                        outline
                        onClick={() => handleChange("period", 7)}
                        active={activeButton === 7}
                    >
                        Weekly
                    </Button>
                    <Button
                        className='btn mr-0'
                        value={30}
                        outline
                        onClick={() => handleChange("period", 30)}
                        active={activeButton === 30}
                    >
                        Monthly
                    </Button>
                    <Button
                        className='btn mr-0'
                        value={75}
                        outline
                        onClick={() => handleChange("period", 90)}
                        active={activeButton === 90}
                    >
                        Quarterly    
                    </Button>
                    <Button
                        className='btn'
                        value={350}
                        outline
                        onClick={() => handleChange("period", 350)}
                        active={activeButton === 350}
                    >
                        Annually    
                    </Button>
                </ButtonGroup>
            </Col>
            <Col>
                <DateComponent fieldKey={"date"} />
            </Col>
        </Row>
    );
}

export default ControlPanel;
